
 const dataTables = {
  data() {
    return {
      renderedComponent: true,
      tableClass: 'table-striped table-bordered responsive nowrap',
      tableInitOptions: {
        destroy: true,
        responsive: true,
        details: false,
        select: true,
        bAutoWidth: false,
        drawCallback() {
          var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
          pagination.toggle(this.api().page.info().pages > 1);
        }
      },
    }
  },
  methods: {
    renderComponent() {
      this.renderedComponent = false;

      this.$nextTick(() => {
        this.renderedComponent = true;
      });
    },
  },
  mounted() {
    // Overwrite Bootstrap dropdown Toggle
    $('.dropdown .dropdown-toggle').on('click', function () {
      $(this).parent().toggleClass('show');
      $(this).siblings().toggleClass('show');
    });
    $('body').on('click', function (e) {
      if (!$('.dropdown').is(e.target)
          && $('.dropdown').has(e.target).length === 0
          && $('.open').has(e.target).length === 0
      ) {
        $('.dropdown-menu').removeClass('show');
      }
    });
  },
}


 export  default  dataTables